import { useQuery, useMutation } from "@tanstack/react-query";
import axios from "axios";
import { UserDetailModel } from "../types/models";

// Shared by AuthProvider and AccountProvider - both need the same /auth/getUser bootstrap
// response; TanStack Query dedupes concurrent callers with this key into a single request.
export const userDetailQueryKey = ['userDetail'] as const;

export const useUserDetailQuery = () => {
    return useQuery({
        queryKey: userDetailQueryKey,
        queryFn: async () => {
            const response = await axios.post<UserDetailModel>('/auth/getUser', {});
            return response.data;
        },
        staleTime: Infinity,
        retry: false,
    });
};

export const usePasswordRules = (resourceId: number) => {
    return useQuery({
        queryKey: ['passwordRules', resourceId],
        queryFn: async () => {
            const response = await axios.get<{ Response: string }>('/accountmanagement/getpasswordrules', { params: { resourceId } });
            return response.data.Response ?? '';
        },
        enabled: resourceId > 0,
    });
};

// Not intended for direct use by components - AccountContext.unlockAccount() is the only
// caller; it owns translating the raw response string into lockStatus/isLocked.
export const useUnlockAccountMutation = () => {
    return useMutation({
        mutationFn: async (resourceId: number) => {
            const response = await axios.post<string>('/accountmanagement/unlockaccount', { resourceId });
            return response.data;
        },
    });
};
